import { API_BASE_URL } from "src/config/apiBase";
import React, { useEffect, useState } from "react";
import Select from "react-select";
import '../../CSS/Global.css';
import { getDecryptedUserFromCookie } from "../utils/getCookie";
import axios from 'axios'
import { toast } from "react-toastify";
import { v4 as uuidv4 } from 'uuid';
import { decryptToken } from "../utils/getToken";



const ItemTable = ({ items, setItems, subtotal, setSubtotal, itemsOptions, setItemsOptions, taxAmountTotal, setTaxAmountTotal, discountAmountTotal, setDisountamountTotal }) => {
    const url = API_BASE_URL;
    const isLoggedIn = getDecryptedUserFromCookie("gta_mainstateuser");
    const [showVariationModal, setShowVariationModal] = useState(false);
    const [currentVariableProduct, setCurrentVariableProduct] = useState(null);
    const [selectedRowId, setSelectedRowId] = useState(null);
    const token = decryptToken("accessToken") || ""
    console.log(discountAmountTotal, taxAmountTotal)


    const fetchServiceData = async () => {
        try {
            const response = await axios.get(
                `${url}/grouped-product/search-all-products/${isLoggedIn.main_id}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                    params: { includeInactive: true },
                }
            );

            const productOptions = response.data.map(product => {
                let variation = [];

                if (product.variation) {
                    if (typeof product.variation === "string") {
                        try {
                            variation = JSON.parse(product.variation);
                        } catch (e) {
                            console.error("Invalid variation JSON:", product.variation);
                            variation = [];
                        }
                    } else {
                        // already object/array
                        variation = product.variation;
                    }
                }

                return {
                    label: product.title,
                    value: {
                        id: product.id,
                        title: product.title,
                        hsn: product.hsn,
                        product_type: product.product_type,
                        salePrice: product.salePrice,
                        discountPrice: product.discountPrice,
                        sku: product.sku || product.product_id,
                        variation
                    }
                };
            });

            setItemsOptions(productOptions);

        } catch (error) {
            console.log("Fetch error:", error);
        }
    };

    console.log(itemsOptions)

    const handleInputChange = (id, field, value) => {
        if (field === "item") {
            // Variable Product: Open modal
            if (value.product_type === "Variable Product") {
                setCurrentVariableProduct(value);
                setSelectedRowId(id);
                setShowVariationModal(true);
                return;
            }

            // ✅ Non-variable: Set rate directly
            const updatedRows = items.map(row =>
                row.id === id
                    ? {
                        ...row,
                        item: { title: `${value.title} - ${value.sku}` },
                        rate: value.discountPrice || value.salePrice || "",
                        quantity: row.quantity && parseFloat(row.quantity) > 0 ? row.quantity : "1",
                        hsn: value.hsn || ""
                    }
                    : row
            );
            setItems(updatedRows);
            recalculateSubtotal(updatedRows);
            return;
        }

        // Handle other fields (quantity, rate, etc.)
        const updatedRows = items.map(row =>
            row.id === id ? { ...row, [field]: value } : row
        );
        setItems(updatedRows);
        recalculateSubtotal(updatedRows);
    };


    const recalculateSubtotal = (updatedItems) => {
        // console.log(updatedItems)
        if (!Array.isArray(updatedItems)) {
            console.warn("recalculateSubtotal called with invalid data:", updatedItems);
            return;
        }
        const newSubtotal = updatedItems.reduce((acc, row) => {
            const qty = parseFloat(row.quantity) || 0;
            const rate = parseFloat(row.rate) || 0;
            const discount = parseFloat(row.discount) || 0;
            const tax = parseFloat(row.tax) || 0;
            return acc + qty * rate * (1 - discount / 100) * (1 + tax / 100);
        }, 0);
        setSubtotal(parseFloat(newSubtotal.toFixed(2)));
    };

    console.log(subtotal)
    useEffect(() => {
        fetchServiceData();
    }, [])

    return (
        <>


            <div className="item-table-containerreciept">
                <ItemTableMobile
                    items={items}
                    setItems={setItems}
                    itemsOptions={itemsOptions}
                    showVariationModal={showVariationModal}
                    setShowVariationModal={setShowVariationModal}
                    currentVariableProduct={currentVariableProduct}
                    setCurrentVariableProduct={setCurrentVariableProduct}
                    setSelectedRowId={setSelectedRowId}
                    recalculateSubtotal={recalculateSubtotal}
                    setSubtotal={setSubtotal}
                    setTaxAmountTotal={setTaxAmountTotal}
                    setDisountamountTotal={setDisountamountTotal}
                />

            </div>
            {showVariationModal && currentVariableProduct && (
                <div className="modal-overlay">
                    <div className="modal-content">
                        <h3>Select Variation for {currentVariableProduct.title}</h3>
                        {currentVariableProduct.variation.map(v => (
                            <div key={v.id} className="variation-item" onClick={() => {
                                const updated = items.map(row => row.id === selectedRowId ? {
                                    ...row,
                                    item: { title: `${currentVariableProduct.title} - ${v.sku}` },
                                    hsn: currentVariableProduct.hsn,
                                    rate: v.salePrice
                                } : row);
                                setItems(updated);
                                recalculateSubtotal(updated);
                                setShowVariationModal(false);
                            }}>
                                <img src={`${url}${v.imageUrl}`} alt="variation" width="50" />
                                <div>
                                    <p>SKU: {v.sku}</p>
                                    <p>Price: ₹{v.salePrice}</p>
                                    <p>Stock: {v.stock}</p>
                                </div>
                            </div>
                        ))}
                        <button onClick={() => setShowVariationModal(false)}>Cancel</button>
                    </div>
                </div>
            )}

        </>
    );
};

export default ItemTable;






const ItemTableMobile = ({ items,
    setItems,
    itemsOptions,
    showVariationModal,
    setShowVariationModal,
    currentVariableProduct,
    setCurrentVariableProduct,
    setSelectedRowId,
    recalculateSubtotal,
    setSubtotal,
    setDisountamountTotal,
    setTaxAmountTotal
}) => {

    const user = getDecryptedUserFromCookie("gta_mainstateuser");
    const [equipments, setEquipments] = useState([]);

    // const calculateAmount = (quantity, rate, discount, tax) => {
    //     return (
    //         (quantity || 0) *
    //         (rate || 0) *
    //         (1 - (discount || 0) / 100) *
    //         (1 + (tax || 0) / 100)
    //     ).toFixed(2);
    // };

    const updateItemAmounts = (updatedItems) => {
        let totalDiscountAmount = 0;
        let totalTaxAmount = 0;
        const newItems = updatedItems.map(item => {
            const qty = parseFloat(item.quantity) || 0;
            const price = parseFloat(item.rate) || 0;
            const disc = parseFloat(item.discount) || 0;
            const tx = parseFloat(item.tax) || 0;

            const base = qty * price;
            const discountAmount = (base * disc) / 100;
            const taxable = base - discountAmount;
            const taxAmount = (taxable * tx) / 100;

            totalDiscountAmount += discountAmount;
            totalTaxAmount += taxAmount;
            return {
                ...item,
                discount_amount: discountAmount.toFixed(2),
                tax_amount: taxAmount.toFixed(2)
            };
        });

        setDisountamountTotal(totalDiscountAmount.toFixed(2));
        setTaxAmountTotal(totalTaxAmount.toFixed(2));
        return newItems; // ✅ return so caller can use it
    };


    const calculateAmount = (quantity, rate, discount, tax, amount) => {
        if (amount !== undefined && amount !== null && amount !== "" && parseFloat(amount) > 0) {
            return parseFloat(amount).toFixed(2);
        }
        return (
            (quantity || 0) *
            (rate || 0) *
            (1 - (parseFloat(discount) || 0) / 100) *
            (1 + (parseFloat(tax) || 0) / 100)
        ).toFixed(2);
    };



    // const calculateAmount = (quantity, rate, discount, tax, customAmount) => {
    //     const qty = parseFloat(quantity) || 0;
    //     const price = parseFloat(rate) || 0;
    //     const disc = parseFloat(discount) || 0;
    //     const tx = parseFloat(tax) || 0;

    //     if (customAmount && customAmount !== "") {
    //         return {
    //             amount: parseFloat(customAmount).toFixed(2),
    //             discount_amount: 0,
    //             tax_amount: 0
    //         };
    //     }

    //     const base = qty * price;
    //     const discountAmount = (base * disc) / 100;
    //     const taxable = base - discountAmount;
    //     const taxAmount = (taxable * tx) / 100;
    //     const finalAmount = taxable + taxAmount;

    //     return finalAmount.toFixed(2),


    // };



    const handleInputChange = (id, field, value) => {
        if (field === "item") {
            if (value.value.product_type === "Variable Product") {
                setCurrentVariableProduct(value.value);
                setSelectedRowId(id);
                setShowVariationModal(true);
                return;
            }

  
          console.log(items)
            const updatedItems = items.map(item =>
                item.id === id
                    ? {
                        ...item,
                        item: { title: `${value.value.title} - ${value.value.sku}` },
                        rate: value.value.discountPrice || value.value.price || "",
                        quantity: item.quantity && parseFloat(item.quantity) > 0 ? item.quantity : "1",
                        tax_amount: item.tax_amount,
                        discount_amount: item.discount,
                        hsn: value?.value?.hsn || ""
                    }
                    : item
            );
            console.log(updatedItems)
            const recalculatedItems = updateItemAmounts(updatedItems); // <- fix: make this return updated items
            recalculateSubtotal(recalculatedItems);
            setItems(recalculatedItems);
            // calculateAmount()
            return;
        }

        const updatedItems = items.map(item =>
            item.id === id ? { ...item, [field]: value } : item
        );
        const recalculatedItems = updateItemAmounts(updatedItems); // <- fix: make this return updated items
        recalculateSubtotal(recalculatedItems);
        setItems(recalculatedItems);
    };




    const handleAddRow = () => {
        setItems([
            ...items,
            {
                id: Date.now(), item: null, quantity: "1", rate: "", discount: "", tax: "", amount: 0, discount_amount: 0,
                tax_amount: 0, hsn: ""
            },
        ]);
    };


    const handleDeleteRow = (id) => {
        const filtered = items.filter(row => row.id !== id);
        setItems(filtered);
        recalculateSubtotal(filtered);

    };



    // console.log(items)

    return (
        <div className="oms-modal-form">
            {items.map((item) => (
                <div key={item.id} className="item-row">
                    <div className="oms-form-group">
                        <label htmlFor={`item-${item.id}`} className="oms-form-label">
                            Item
                        </label>

                        <Select
                            options={itemsOptions}
                            // value={
                            //     item.item?.title
                            //         ? {
                            //             label: item.item.title,
                            //             value: item.item,
                            //         }
                            //         : item.item || null
                            // }
                            value={
                                item.item && item.item.id
                                    ? itemsOptions.find(opt => opt.value.id === item.item.id)
                                    : item.item && item.item.title
                                        ? { label: item.item.title, value: item.item }
                                        : null
                            }
                            onChange={(selectedOption) =>
                                handleInputChange(item.id, "item", selectedOption)
                            }
                            placeholder="Select Item"
                            id={`item-${item.id}`}
                        />

                    </div>
                    <div className="oms-form-group">
                        <label htmlFor={`hsn-${item.hsn}`} className="oms-form-label">
                            HSN
                        </label>
                        <input
                            type="text"
                            id={`item-${item.hsn}`}
                            value={item.hsn || ""}
                            onChange={(e) =>
                                handleInputChange(item.id, "hsn", parseFloat(e.target.value))
                            }
                            readOnly
                            className="readonly-input"
                            placeholder="HSN Code"
                        />
                    </div>
                    {/* { console.log(item.item.value.title)} */}
                    <div className="oms-form-group">
                        <label htmlFor={`quantity-${item.id}`} className="oms-form-label">
                            Quantity
                        </label>
                        <input
                            type="number"
                            id={`quantity-${item.id}`}
                            placeholder="Enter quantity"
                            value={item.quantity}
                            onChange={(e) =>
                                handleInputChange(item.id, "quantity", parseFloat(e.target.value))
                            }
                            onWheel={(e) => e.target.blur()}
                        />
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor={`rate-${item.id}`} className="oms-form-label">
                            Rate
                        </label>
                        <input
                            type="number"
                            id={`rate-${item.id}`}
                            placeholder="Enter rate"
                            value={item.rate}
                            onChange={(e) =>
                                handleInputChange(item.id, "rate", parseFloat(e.target.value))
                            }
                            onWheel={(e) => e.target.blur()}
                        />
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor={`discount-${item.id}`} className="oms-form-label">
                            Discount (%)
                        </label>
                        {/* <input
                            type="number"
                            id={`discount-${item.id}`}
                            name={`discount-${item.id}`}
                            placeholder="Enter discount"
                            value={item.discount}
                            // onChange={(e) =>
                            //     handleInputChange(item.id, "discount", parseFloat(e.target.value))
                            // }
                            onChange={(e) => handleInputChange(item.id, "discount", e.target.value)}

                            onBlur={(e) => {
                                const value = parseFloat(e.target.value);
                                if (isNaN(value) || value < 0 || value > 100) {
                                    toast.warning("Please enter a valid discount (0–100%)");
                                    handleInputChange(item.id, "discount", "");
                                } else {
                                    handleInputChange(item.id, "discount", value.toFixed(2));
                                }
                            }}

                            min="0"
                            max="100"
                        /> */}
                        <input
                            type="number"
                            name={`discount-${item.id}`}
                            id={`discount-${item.id}`}
                            placeholder="Enter discount"
                            value={item.discount}
                            step="any" // ✅ Allow decimal steps
                            onChange={(e) => handleInputChange(item.id, "discount", e.target.value)}
                            onBlur={(e) => {
                                const value = parseFloat(e.target.value);
                                if (isNaN(value) || value < 0 || value > 100) {
                                    toast.warning("Please enter a valid discount (0–100%)");
                                    handleInputChange(item.id, "discount", "");
                                } else {
                                    handleInputChange(item.id, "discount", parseFloat(value).toFixed(2));
                                }
                            }}
                            onWheel={(e) => e.target.blur()}
                            min="0"
                            max="100"
                        />

                    </div>
                    <div className="oms-form-group">
                        <label htmlFor={`tax-${item.id}`} className="oms-form-label">
                            Tax (%)
                        </label>
                        <input
                            type="number"
                            id={`tax-${item.id}`}
                            placeholder="Enter tax"
                            value={item.tax}
                            onChange={(e) =>
                                handleInputChange(item.id, "tax", parseFloat(e.target.value))
                            }
                            onWheel={(e) => e.target.blur()}
                            min="0"
                            max="100"
                        />
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor={`amount-${item.id}`} className="oms-form-label">
                            Total Amount
                        </label>
                        <input
                            type="text"
                            id={`amount-${item.id}`}
                            // value={calculateAmount(item.quantity, item.rate, item.discount, item.tax, item.amount)}
                            value={calculateAmount(item.quantity, item.rate, item.discount, item.tax)}

                            readOnly
                            className="readonly-input"
                        />
                    </div>
                    <button
                        type="button"
                        onClick={() => handleDeleteRow(item.id)}
                        className="mobile-delete-row-btn"
                    >
                        <i class="fa-solid fa-trash-can"></i>  Delete item
                    </button>
                </div>
            ))}
            <button type="button" onClick={handleAddRow} className="add-row-btn">
                Add item
            </button>
        </div>
    );
};
